import { VideoContainer } from './shared/video-container';
import { RightBar } from './shared/right-bar';
import { BottomBar } from './shared/bottom-bar';
import { useScrollTransition } from './useScrollTransition';
import { useCasesRegistry, getUseCaseByIndex } from './use-cases-registry';

export function TransitionLayout() {
  const {
    sectionRef,
    videoRefs,
    rightBarRef,
    bottomBarRef,
    activeUseCaseIndex,
  } = useScrollTransition();

  // Get the current use case data based on active index
  const currentUseCase = getUseCaseByIndex(activeUseCaseIndex);

  if (!currentUseCase) {
    return null;
  }

  // Convert use case to project data format for RightBar
  const projectData = {
    slug: currentUseCase.id,
    title: currentUseCase.title,
    description: currentUseCase.subtitle,
    sections: currentUseCase.sections,
    buttons: {
      detailPath: currentUseCase.detailPath
    }
  };

  return (
    <div
      ref={sectionRef}
      className="flex flex-col gap-16"
    >
      {/* Content Container */}
      <div className="w-full h-[700px]">
        <div className="grid grid-cols-1 [@media(min-width:1390px)]:grid-cols-3 grid-rows-[1fr_auto] [@media(min-width:1390px)]:grid-rows-none gap-2 [@media(min-width:1390px)]:gap-6 h-full">
          {/* Left side - Overlapping Videos and BottomBar */}
          <div className="[@media(min-width:1390px)]:col-span-2 flex flex-col gap-6 h-full">
            {/* Video Container - Takes most height on small screens, flex-[3] on large screens */}
            <div className="bento-square flex-[4] [@media(min-width:1390px)]:flex-[3] relative overflow-hidden">
              {/* Render all use case videos for scroll transition */}
              {useCasesRegistry.map((useCase, index) => (
                <div
                  key={useCase.id}
                  ref={(el) => { videoRefs[index].current = el; }}
                  className="absolute inset-0 w-full h-full"
                >
                  <VideoContainer useCaseIndex={index} />
                </div>
              ))}
            </div>

            {/* Bottom Bar - Minimal height on small screens, flex-1 on large screens */}
            <div
              ref={bottomBarRef}
              className="bg-card border border-border rounded-[2rem] p-4 [@media(min-width:1390px)]:p-8[@media(min-width:1390px)]:h-auto [@media(min-width:1390px)]:min-h-[200px] transition-all duration-300 ease-in-out hover:border-primary/40 hover:-translate-y-0.5 hover:shadow-lg flex-none [@media(min-width:1390px)]:flex-1 [@media(min-width:1390px)]:mb-0 mb-3"
            >
              <BottomBar techStack={currentUseCase.techStack} />
            </div>
          </div>

          {/* Right side - RightBar with conditional bento-square styling and minimal height on small screens */}
          <div
            ref={rightBarRef}
            className="[@media(min-width:1390px)]:h-auto [@media(min-width:1390px)]:bg-card [@media(min-width:1390px)]:border [@media(min-width:1390px)]:border-border [@media(min-width:1390px)]:rounded-[2rem] [@media(min-width:1390px)]:p-8 [@media(min-width:1390px)]:min-h-[200px] [@media(min-width:1390px)]:transition-all [@media(min-width:1390px)]:duration-300 [@media(min-width:1390px)]:ease-in-out [@media(min-width:1390px)]:hover:border-primary/40 [@media(min-width:1390px)]:hover:-translate-y-0.5 [@media(min-width:1390px)]:hover:shadow-lg flex-none"
          >
            <RightBar projectData={projectData} />
          </div>
        </div>
      </div>
    </div>
  );
}